import * as TYPES from './type';
export default {
  //授课计划
  [TYPES.PLAN_LIST](state, { result }) {
    state.planList = result.result
  },
  [TYPES.PLAN_INFO](state, { result, type }) {
    state.planInfo[type] = result.result
  },
  [TYPES.COURSE_DELETE](state,result) {
    state.deleteById = result
  },
  [TYPES.ADD_XZ_CLASS](state,result) {
    state.addXzClass = result
  },
  [TYPES.VIEW_COURSE_TREE](state,result) {
    state.viewCourseTree = result
  },
  
}



// WEBPACK FOOTER //
// ./src/store/skPlan/mutations.js